import { SimplePaginator } from '../models/simple-paginator.interfaces';

export const SimplePaginatorMocks: SimplePaginator = {
  total: 1,
  current: 1,
  label: 'Card (1/5)',
  ariaLabels: {
    previous: 'Previous Arrow',
    next: 'Next Arrow',
    indicator: 'Card (1/5)'
  }
};

export const SimplePaginator2Mocks: SimplePaginator = {
  total: 2,
  current: 2,
  label: 'Card (2/2)',
  ariaLabels: {
    previous: 'Previous Arrow',
    next: 'Next Arrow',
    indicator: 'Card (2/2)'
  }
};

export const SimplePaginator3Mocks: SimplePaginator = {
  total: 3,
  current: 3,
  label: 'Card (3/3)',
  ariaLabels: {
    previous: 'Previous Arrow',
    next: 'Next Arrow',
    indicator: 'Card (3/3)'
  }
};

export const SimplePaginator4Mocks: SimplePaginator = {
  total: 4,
  current: 4,
  label: 'Card (4/4)',
  ariaLabels: {
    previous: 'Previous Arrow',
    next: 'Next Arrow',
    indicator: 'Card (4/4)'
  }
};

export const SimplePaginator5Mocks: SimplePaginator = {
  total: 5,
  current: 5,
  label: 'Card (5/5)',
  ariaLabels: {
    previous: 'Previous Arrow',
    next: 'Next Arrow',
    indicator: 'Card (5/5)'
  }
};

export const SimplePaginator6Mocks: SimplePaginator = {
  total: 6,
  current: 6,
  label: 'Card (6/6)',
  ariaLabels: {
    previous: 'Previous Arrow',
    next: 'Next Arrow',
    indicator: 'Card (6/6)'
  }
};

export const SimplePaginator7Mocks: SimplePaginator = {
  total: 7,
  current: 7,
  label: 'Card (7/7)',
  ariaLabels: {
    previous: 'Previous Arrow',
    next: 'Next Arrow',
    indicator: 'Card (7/7)'
  }
};

export const SimplePaginator8Mocks: SimplePaginator = {
  total: 8,
  current: 8,
  label: 'Card (8/8)',
  ariaLabels: {
    previous: 'Previous Arrow',
    next: 'Next Arrow',
    indicator: 'Card (8/8)'
  }
};

export const SimplePaginator9Mocks: SimplePaginator = {
  total: 9,
  current: 9,
  label: 'Card (9/9)',
  ariaLabels: {
    previous: 'Previous Arrow',
    next: 'Next Arrow',
    indicator: 'Card (9/9)'
  }
};

export const SimplePaginator10Mocks: SimplePaginator = {
  total: 10,
  current: 10,
  label: 'Card (10/10)',
  ariaLabels: {
    previous: 'Previous Arrow',
    next: 'Next Arrow',
    indicator: 'Card (10/10)'
  }
};

export const SimplePaginator11Mocks: SimplePaginator = {
  total: 11,
  current: 11,
  label: 'Card (11/11)',
  ariaLabels: {
    previous: 'Previous Arrow',
    next: 'Next Arrow',
    indicator: 'Card (11/11)'
  }
};

export const SimplePaginator12Mocks: SimplePaginator = {
  total: 12,
  current: 12,
  label: 'Card (12/12)',
  ariaLabels: {
    previous: 'Previous Arrow',
    next: 'Next Arrow',
    indicator: 'Card (12/12)'
  }
};

export const SimplePaginator13Mocks: SimplePaginator = {
  total: 13,
  current: 13,
  label: 'Card (13/13)',
  ariaLabels: {
    previous: 'Previous Arrow',
    next: 'Next Arrow',
    indicator: 'Card (13/13)'
  }
};
